import send from './request';

export function getAREA(params = {}) {//收货地址
  return send({ url: '/ipp/common/area', method: 'GET', params });
}

export function getProductList(data = {}) {//商品详情
  return send({ url: '/ipp/product/info', method: 'POST', data });
}

export function orderPlanTaskReserve(params = {}) {
  return send({ url: '/ipp/order-plan-task/reserve', method: 'POST', data: params });
}

export function orderPlanTaskReserveList(params = {}) {
  return send({ url: '/ipp/order-plan-task/reserve-list', method: 'POST', data: params });
}

export function orderDomesticShoppingCart(params = {}) {
  return send({ url: '/ipp/order-domestic/shopping-cart', method: 'POST', data: params });
}

export function orderPlanTaskReserveListAddress(params = {}) {
  return send({ url: '/ipp/order-plan-task/reserve-list-address', method: 'POST', data: params });
}

// 公司仓库列表
export function userAddressWarehouseList(params = {}) {
  return send({ url: '/ipp/user-address/warehouse-list', method: 'POST', data: params });
}






